<script setup>
import { computed } from 'vue'

import { getI18n } from '@/plugins/i18n'

import { DxButton } from 'devextreme-vue/button'

const props = defineProps({
  masterEntityId: {
    type: Number,
    required: true
  },
  entityLock: {
    type: Object,
    required: true
  },
  readOnly: {
    type: Boolean,
    default: false
  },
  hasRoundingRow: {
    type: Boolean,
    default: false
  },
  hasRoundingExpenseRow: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['add-rounding-row', 'add-expense-percentage-row'])

const i18n = getI18n()

const isLockedByAnother = computed(() => props.entityLock?.isLocked(false, props.masterEntityId))
const roundingDisabled = computed(() => props.readOnly || props.hasRoundingRow || isLockedByAnother.value)
const expensePercentageDisabled = computed(() => roundingDisabled.value || props.hasRoundingExpenseRow)
</script>

<template>
  <div class="row no-wrap">
    <span :class="{ 'rounding-button': !roundingDisabled }">
      <dx-button
        icon="mdi mdi-calculator"
        :hint="i18n.t('common.rounding')"
        styling-mode="text"
        :disabled="roundingDisabled"
        @click="emit('add-rounding-row')"
      />
    </span>
    <span :class="{ 'rounding-button': !expensePercentageDisabled }">
      <dx-button
        icon="mdi mdi-brightness-percent"
        :hint="i18n.t('common.expensePercentage')"
        styling-mode="text"
        :disabled="expensePercentageDisabled"
        @click="emit('add-expense-percentage-row')"
      />
    </span>
  </div>
</template>
